import { render, staticRenderFns } from "./fj_record.vue?vue&type=template&id=854973a8&scoped=true&"
import script from "./fj_record.vue?vue&type=script&lang=js&"
export * from "./fj_record.vue?vue&type=script&lang=js&"
import style0 from "./fj_record.vue?vue&type=style&index=0&id=854973a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854973a8",
  null
  
)

export default component.exports